export enum ProviderType {
  Google = 1,
  Microsoft = 2,
}
